module.exports = __webpack_public_path__ + "static/media/grid_view_icon_blue.d850fa98.svg";